import React, { useState, useEffect } from "react"; // HELE ER COPY PASTE AV CHAT, SE IGJENNOM 
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/CSS/UserSearch.css"; 

function UserSearch() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      if (query.trim() === "") {
        setResults([]);
        return;
      }

      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/search?query=${query}`);
        setResults(response.data);
      } catch (error) {
        console.error("Search error:", error);
        setResults([]);
      }
    };

    const debounceTimeout = setTimeout(fetchUsers, 300); // delay for sanntid
    return () => clearTimeout(debounceTimeout);
  }, [query]);

  const handleSelect = (id) => {
    setQuery("");
    setResults([]);
    navigate(`/profile/${id}`);
  };

  return (
    <div className="user-search-container">
      <input
        type="text"
        className="ZingSearch"
        placeholder="Search..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {results.length > 0 && (
        <ul className="search-dropdown">
          {results.map((user) => (
            <li key={user.id} onClick={() => handleSelect(user.id)}>
              {user.firstName} {user.lastName}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default UserSearch;
